import styled from 'styled-components';

export const StyledLayer = styled.div`
  background-color: ${(p) => p.theme.alias.layer};
  top: ${(p) => p.theme.space[0]};
  left: ${(p) => p.theme.space[0]};
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 1;
  position: fixed;

  ${(p) =>
    p.isCentered &&
    `
    align-items: center;
    justify-content: center;
  `}
`;
